import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import { TransactionTable } from '../components/TransactionTable';
import { Pagination } from '../components/Pagination';
import { TransactionsFilters } from '../components/TransactionsFilters';
import { Skeleton } from '../components/ui/skeleton';
import { PageHeader } from '@/components/layout/page-header';

export function TransactionsPage() {
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams);

  const page = Math.max(1, parseInt(params.page ?? '1', 10));
  const card_id = params.card ? parseInt(params.card, 10) : undefined;
  const department =
    params.department === 'unassigned'
      ? ('unassigned' as const)
      : params.department
        ? parseInt(params.department, 10)
        : undefined;
  const amount_min_raw = params.amount_min ? Number(params.amount_min) : undefined;
  const amount_max_raw = params.amount_max ? Number(params.amount_max) : undefined;
  const filters = {
    page,
    card_id,
    department,
    date_from: params.date_from,
    date_to: params.date_to,
    type: params.type as 'purchase' | 'refund' | 'fee' | 'decline' | undefined,
    q: params.q,
    has_alert: params.has_alert === '1',
    amount_min: Number.isFinite(amount_min_raw) ? amount_min_raw : undefined,
    amount_max: Number.isFinite(amount_max_raw) ? amount_max_raw : undefined,
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ['txs', filters],
    queryFn: () => api.listTransactions(filters),
  });

  return (
    <div className="space-y-4">
      <PageHeader
        title="Transactions"
        subtitle={data ? `${data.total_count.toLocaleString('vi-VN')} total` : undefined}
        actions={
          <a
            href={`/api/transactions/export.xlsx?${searchParams.toString()}`}
            download
            className="inline-flex shrink-0 items-center rounded border border-border bg-card px-3 py-1.5 text-sm text-foreground whitespace-nowrap hover:bg-background"
          >
            Xuất Excel
          </a>
        }
      />

      <TransactionsFilters />

      {isLoading && (
        <div className="space-y-2">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-14 w-full" />
          ))}
        </div>
      )}
      {error && (
        <div className="rounded border border-destructive-bg bg-destructive/10 p-4 text-destructive">
          Error: {String(error)}
        </div>
      )}
      {data && (
        <>
          <TransactionTable rows={data.rows} />
          <Pagination page={data.page} totalPages={data.total_pages} />
        </>
      )}
    </div>
  );
}
